import { useContext } from 'react';

import { PlatformContext } from 'components/GlobalContextRegistry';
import { Platform } from 'components/GlobalContextRegistry/GlobalContextRegistry.interface';

export const usePlatformContext = (): Platform => useContext(PlatformContext);
